import { isDataRow, QuantityMap, Row } from '@paragon/layout-models';

import { getFirstDataRowParent } from '../util/getFirstDataRowParent';

const ROWS_WITH_QUANTITY = new Set([
  'project',
  'building',
  'level',
  'componentDesign',
  'profileTrussDesign',
  'featurePatternTrussDesign',
]);

export function addQuantityToDataRowName(currentRowName: string, row: Row, quantityMap: QuantityMap) {
  if (!isDataRow(row) || !row.parent || !ROWS_WITH_QUANTITY.has(row.type)) {
    return currentRowName;
  }

  const parent = getFirstDataRowParent(row);

  // For component designs that aren't in a project, it's possible for getFirstDataRowParent to return null even when
  //   the check for row.parent above passes.
  if (parent === null) {
    return currentRowName;
  }

  const rowItem = row.item as { guid: string };
  const quantity = quantityMap[rowItem.guid] ? quantityMap[rowItem.guid][parent.item.guid] : 1;

  return `${currentRowName}${quantity > 1 ? ` (${quantity})` : ''}`;
}
